import React from "react";
import { FaqMarkdownPage } from "../../components/FaqMarkdownPage";

// Routed at /faq/professional-summary — content lives entirely in
// public/locales/faq/professional-summary.*.md, editable without touching this file.
export const ProfessionalSummaryFaqPage: React.FC = () => (
    <FaqMarkdownPage
        titleKey="FAQ_PROFESSIONAL_SUMMARY_TITLE"
        titleFallback="Professional Summary — Multiple Versions & Generate Summary (AI)"
        markdownBasePath="/locales/faq/professional-summary"
    />
);
